<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('detailTransferReport.detailTransfer') }}
      </h1>
      <ts-breadcrumb :items="[
        { text: $t('home'), href: '/' },
        {
          text: $t('detailTransferReport.detailTransfer'),
          active: true
        }
      ]" />
    </div>
    <div class="row">
      <div class="col-md-3">
        <div class="form-group">
          <ts-card>
            <ts-card-wrapper>
              <ts-loading-banner :loading="loading">
                <form>
                  <fieldset>
                    <legend>{{ $t('detailTransferReport.criteria') }}</legend>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="required">{{
                            $t('detailTransferReport.dateRange')
                          }}</label>
                          <a-range-picker format="DD-MM-YYYY" :defaultValue="rangeDate" :defaultPickerValue="rangeDate"
                            @change="dateRangeChange" :ranges="{
                              Today: [moment(), moment()],
                              'This Month': [
                                moment().startOf('month'),
                                moment().endOf('month')
                              ]
                            }">
                            <template slot="renderExtraFooter"></template>
                          </a-range-picker>
                          <div class="validate" v-if="errors.has('date_range')">
                            {{ errors.first('date_range') }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="required">{{
                            $t('monthlySaleItem.branchName')
                          }}</label>
                          <a-select v-model="model.branch_id" :options="branches" class="ts-w-full" showSearch
                            mode="multiple" :filterOption="(input, option) =>
                              option.componentOptions.children[0].text
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                              " @change="changeBranch" :maxTagCount="1"></a-select>
                          <div class="validate" v-if="errors.has('branch_id')">
                            {{ errors.first('branch_id') }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label>{{
                            $t('detailTransferReport.location')
                          }}</label>
                          <a-select v-model="model.location_id" :options="locations" class="ts-w-full" showSearch
                            mode="multiple" :filterOption="(input, option) =>
                              option.componentOptions.children[0].text
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                              " :maxTagCount="1" :placeholder="$t('all')"></a-select>
                          <div class="validate" v-if="errors.has('location_id')">
                            {{ errors.first('location_id') }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label>{{
                            $t('detailTransferReport.category')
                          }}</label>
                          <a-select v-model="model.category_id" :options="categories" mode="multiple" showSearch
                            @change="clearProduct" :filterOption="(input, option) =>
                              option.componentOptions.children[0].text
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                              " class="ts-w-full" :placeholder="$t('all')"></a-select>
                          <div class="validate" v-if="errors.has('category_id')">
                            {{ errors.first('category_id') }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label>{{ $t('detailTransferReport.group') }}</label>
                          <a-select v-model="model.pro_group_id" :options="groupsList" mode="multiple" showSearch
                            @change="clearProduct" :filterOption="(input, option) =>
                              option.componentOptions.children[0].text
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                              " class="ts-w-full" :placeholder="$t('all')"></a-select>
                          <div class="validate" v-if="errors.has('pro_group_id')">
                            {{ errors.first('pro_group_id') }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12 form-group">
                        <label>{{ $t('detailTransferReport.product') }}</label>
                        <a-select v-model="model.product_id" mode="multiple" :loading="on_search_product"
                          @search="onProductSearch" :disabled="showSearchProduct" :show-arrow="false"
                          :filter-option="true" :not-found-content="null" :placeholder="$t('all')" :filterOption="(input, option) =>
                            option.componentOptions.children[0].text
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                            ">
                          <a-select-option v-for="product in productList" :key="product.value" :value="product.value">
                            {{ product.label }}
                          </a-select-option>
                        </a-select>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6 text-right">
                        <ts-button class="btn-block" outline color="success" @click.prevent="exportExcel"
                          :waiting="exporting"><i class="fas fa-file-excel"></i>
                          {{ $t('excel') }}</ts-button>
                      </div>
                      <div class="col-md-6 text-right">
                        <ts-button class="btn-block" color="primary" @click.prevent="preview" :waiting="waiting"><i
                            class="fas fa-file-pdf text-red"></i>
                          {{ $t('preview') }}</ts-button>
                      </div>
                    </div>
                  </fieldset>
                </form>
              </ts-loading-banner>
            </ts-card-wrapper>
          </ts-card>
        </div>
      </div>
      <div class="col-md-9">
        <ts-card>
          <ts-card-wrapper>
            <form>
              <fieldset>
                <legend>{{ $t('detailTransferReport.preview') }}</legend>
                <ts-preview-pdf v-model="waiting" :src="src" />
              </fieldset>
            </form>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import { mapActions } from 'vuex'
import * as FileDownload from 'downloadjs'
import { trim } from 'lodash'

export default {
  name: 'report-detail-transfer',
  data() {
    return {
      is_as_of_date: false,
      waiting: false,
      exporting: false,
      loading: false,
      errors: new Errors(),
      locations: [],
      branches: [],
      groups: [],
      productList: [],
      categories: [],
      on_search_product: false,
      src: '',
      rangeDate: [moment(), moment()],

      model: {
        branch_id: [],
        location_id: [],
        pro_group_id: [],
        category_id: [],
        product_id: []
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  },
  computed: {
    asOfDate: {
      get() {
        return this.$store.state.report.inventory.date_to
      },
      set(newValue) {
        this.$store.commit('report/inventory/SET_DATE_FROM', null)
        this.$store.commit('report/inventory/SET_DATE_TO', newValue)
      }
    },
    showSearchProduct() {
      return this.model.location_id == '' || this.model.location_id == undefined
    },
    groupsList() {
      if (this.model.category_id.length > 0) {
        return this.groups
          .filter(g => _.includes(this.model.category_id, g.category_id))
          .map(el => ({
            value: el.pro_group_id,
            label: el.pro_group_name_en
          }))
      }
      return this.groups.map(el => ({
        value: el.pro_group_id,
        label: el.pro_group_name_en
      }))
    }
  },
  methods: {
    ...mapActions('report/resource', [
      'getLocation',
      'getBranch',
      'productGroup',
      'productCategory',
      'productProfileLocationList'
    ]),
    moment,
    async fetchData() {
      this.loading = true
      await this.productGroup().then(response => {
        this.groups = response.data
      })
      await this.productCategory().then(response => {
        this.categories = response.data.map(el => ({
          value: el.category_id,
          label: el.category_name_en
        }))
      })
      await this.getBranch().then(response => {
        this.branches = response.data.map(el => ({
          value: el.branch_id,
          label: el.branch_name_en
        }))
        this.model.branch_id.push(
          this.$store.state.authUser.user.default_branch.branch_id
        )
        this.changeBranch()
      })

      await this.productCategory()
        .then(response => {
          this.categories = response.data.map(el => ({
            value: el.category_id,
            label: el.category_name_en
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onProductSearch: _.debounce(function (value) {
      this.on_search_product = true
      this.productProfileLocationList({
        filter: {
          search: value
        },
        category_id: this.model.category_id,
        pro_group_id: this.model.pro_group_id,
        location_id: this.model.location_id
      })
        .then(response => {
          let product = response.data.map(el => ({
            value: el.product_id,
            label: el.product_name_en
          }))

          let diff = _.differenceBy(...product, this.productList, 'value')

          if (!diff.length > 0) {
            this.productList.push(...product)
          } else {
            this.productList.push(...diff)
          }

          this.productList = _.uniqBy(this.productList, 'value').splice(0, 300)
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.on_search_product = false
        })
    }, 500),
    clearProduct() {
      this.model.product_id = []
      this.productList = []
    },
    changeBranch() {
      this.loading = true
      this.model.location_id = []
      this.products = []
      this.locations = []
      this.getLocation({
        branch_id: this.model.branch_id
      })
        .then(response => {
          this.locations = response.data.map(el => ({
            value: el.location_id,
            label: el.location_name_en + ' | ' + el.branch.branch_name_en
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    preview() {
      this.errors = new Errors()
      this.waiting = true
      this.src = ''
      this.$store
        .dispatch('report/inventory/detailTransfer', this.model)
        .then(response => {
          this.src = response.url
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    exportExcel() {
      this.exporting = true
      this.errors = new Errors()

      this.$store
        .dispatch('report/inventory/detailTransferExcel', this.model)
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.exporting = false))
    },
    dateRangeChange(rangeDate) {
      this.$store.commit(
        'report/inventory/SET_DATE_FROM',
        rangeDate[0].format('DD-MM-YYYY')
      )
      this.$store.commit(
        'report/inventory/SET_DATE_TO',
        rangeDate[1].format('DD-MM-YYYY')
      )
    }
  },
  watch: {
    is_as_of_date: function (val) {
      if (val) {
        this.$store.commit('report/inventory/SET_DATE_FROM', null)
        this.$store.commit(
          'report/inventory/SET_DATE_TO',
          moment().format('DD-MM-YYYY')
        )
      } else {
        this.$store.commit(
          'report/inventory/SET_DATE_FROM',
          moment().format('DD-MM-YYYY')
        )
        this.$store.commit(
          'report/inventory/SET_DATE_TO',
          moment().format('DD-MM-YYYY')
        )
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit(
      'report/inventory/SET_DATE_FROM',
      moment().format('DD-MM-YYYY')
    )
    this.$store.commit(
      'report/inventory/SET_DATE_TO',
      moment().format('DD-MM-YYYY')
    )
    next()
  }
}
</script>
